import { useSelector, connect } from 'react-redux'
import { LockFilled } from '@ant-design/icons'

import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import { isTeamsFeatureEnabled } from '~/redux-modules/identity'
import { openModal } from '~/redux-modules/modals'
import icons from '~/apps/consumer/icons'
import Image from '~/core/Image'

export type PremiumTagPropType = {
    iconOnly?: boolean
    fontSize?: string
    type?: 'premium' | 'non-premium'
    openModal: Function
    isClickOverride?: boolean
    isPremiumIconOnly?: boolean
    closePreviousModal?: Function
}

const PremiumTag = (props: PremiumTagPropType) => {
    const isTeamsFeatureOn = useSelector(isTeamsFeatureEnabled)
    const { type, closePreviousModal } = props

    return (
        <span
            style={{
                whiteSpace: 'nowrap',
                color: getColor('premiumBrandingTxt'),
                fontSize: props.fontSize || '12px',
                fontWeight: 400,
                lineHeight: 1,
                cursor: 'pointer',
            }}
            onClick={e => {
                if (closePreviousModal) {
                    closePreviousModal()
                }
                if (!props.isClickOverride) {
                    e.stopPropagation()
                    props.openModal('UPSELL')
                }
            }}
        >
            {(isTeamsFeatureOn || type === 'premium') &&
                !props.isPremiumIconOnly && (
                    <Image
                        style={{
                            height: '14px',
                            width: '14px',
                            paddingBottom: '2px',
                        }}
                        src={icons.premiumTagImg}
                    />
                )}
            {(!isTeamsFeatureOn || type === 'non-premium') &&
                !props.isPremiumIconOnly && (
                    <LockFilled
                        style={{
                            fontSize: '12px',
                        }}
                    />
                )}
            {(!isTeamsFeatureOn || type === 'non-premium') &&
                props.isPremiumIconOnly && (
                    <Image
                        style={{
                            height: '14px',
                            width: '14px',
                            paddingBottom: '2px',
                        }}
                        src={icons.premiumTagImg}
                    />
                )}
            {!props.iconOnly && (
                <Text
                    style={{
                        marginLeft: '2%',
                    }}
                    data-test-target="premium-txt"
                >
                    PREMIUM
                </Text>
            )}
        </span>
    )
}

export default connect(
    () => {
        return {
            openModal,
        }
    },
    { openModal },
)(PremiumTag)
